export default __webpack_public_path__ + "static/media/wonder-wheel.2edf9ff6.svg";